export const DEFAULT_AVATAR_URL = "/media/defaults/user-default.jpg"

export function resolveAvatarUrl(avatar) {
  const value = (avatar || "").trim()
  return value || DEFAULT_AVATAR_URL
}
